<template>
  <div>
    <back :title="titlename"></back>
    <div class="content"></div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        titlename:"禁寄品"
      }
    }
  }
</script>

<style scoped lang="less">
  .content{
    padding: .33rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Xz.vue